import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BeforeAfterSlider from '../Components/BeforeAfterSlider';
import { AppConstant } from '../AppConstant';

import imgcolor from '../Images/color.png'
import imgline from '../Images/line.png'
import animalseccolorone from '../Images/projectimages/Sculpture_Design_color.png'
import animalseclineone from '../Images/projectimages/Sculpture_Design_line.png'

import lumber_structure_color_one from '../Images/projectimages/lumber_structure_color_one.png'
import lumber_structure_line_one from '../Images/projectimages/lumber_structure_line_one.png'
import lumber1 from '../Images/projectimages/Residence 01.png'
import lumber2 from '../Images/projectimages/Residence 02.png'
import lumber3 from '../Images/projectimages/Residence 03.png'
import lumber4 from '../Images/projectimages/Gable Sheds 01.png'
import lumber5 from '../Images/projectimages/Residence in PA.png'





import Stairs_color_one from '../Images/projectimages/Stairs_color_one.png'
import Stairs_line_one from '../Images/projectimages/Stairs_line_one.png'
import Stairs_image_one from '../Images/projectimages/stairs2.png';
import Stairs_image_two from '../Images/projectimages/Stairs & Railing 02.png';
import Stairs_image_three from '../Images/projectimages/Stairs & Railing 03.png';
import Stairs_image_four from '../Images/projectimages/Stairs & Railing 04.png';
import Stairs_image_five from '../Images/projectimages/Stairs & Railing 05.png';
import Stairs_image_six from '../Images/projectimages/Stairs & Railing 06.png';
import Stairs_image_seven from '../Images/projectimages/Stairs & Railing 07.png';
import Stairs_image_eight from '../Images/projectimages/Stairs & Railing 08.png';
import spiral_stair_one from '../Images/projectimages/spiral stair-1.png';
import spiral_stair_two from '../Images/projectimages/spiral stair-2.png';
import railing from '../Images/projectimages/railingboth.png';
// import railing3d from '../Images/projectimages/railing02.png';




import Solar_Panel_one from '../Images/projectimages/Solar Panel Mounting Structure and foundations.png';
import Solar_Panel_two from '../Images/projectimages/Solar Sculptures 01.png';
import Solar_Panel_three from '../Images/projectimages/Solar Sculptures 02.png';

import CFS1 from '../Images/projectimages/CFS1.jpg';
import CFS2 from '../Images/projectimages/cfscolor.png';
import CFS3 from '../Images/projectimages/cfsline.png';


import cleanroom1 from '../Images/projectimages/cleanroom1.png';
import cleanroom2 from '../Images/projectimages/cleanroom2.png';


import Earthbag_Homes_01 from '../Images/projectimages/Earthbag Homes 01.png';
import Earthbag_Homes_02 from '../Images/projectimages/Earthbag Homes 02.png';
import Earthbag_Homes_03 from '../Images/projectimages/earthhome3.png';


import Sign_Board from '../Images/projectimages/Sign Board Structures.png';
import Sign_Board4 from '../Images/projectimages/signboard4.png';
import Sign_Board5 from '../Images/projectimages/signboard5.png';
import Sign_Board8 from '../Images/projectimages/signboard7.png';
import Sign_Board6 from '../Images/projectimages/signboard8.png';
import Sign_Board7 from '../Images/projectimages/signb9.png';


import loghouse1 from '../Images/projectimages/loghouse1.png';
import loghouse2 from '../Images/projectimages/loghouse2.png';
import loghouse3 from '../Images/projectimages/loghouse3.png';
import loghouse4 from '../Images/projectimages/loghouse4.png';





import Sign_Board1 from '../Images/projectimages/signboard1.png';
import Sign_Board2 from '../Images/projectimages/signboard2.png';
import Sign_Board3 from '../Images/projectimages/signbaord3.png';


import steel1 from '../Images/projectimages/connection-1.png';
import steel2 from '../Images/projectimages/connection-2.png';
import steel3 from '../Images/projectimages/connection-3.png';
import steel4 from '../Images/projectimages/conn1.png';
import steel5 from '../Images/projectimages/conn2.png';
import steel6 from '../Images/projectimages/conn3.png';
import steel7 from '../Images/projectimages/conn11.png';
import steel8 from '../Images/projectimages/conn5.png';
import steel9 from '../Images/projectimages/conn6.png';
import steel10 from '../Images/projectimages/conn10.png';


import shopdrw1 from '../Images/projectimages/Shop Drawings.png'
import shopdrw2 from '../Images/projectimages/shopdrawing2.png'
import shopdrw3 from '../Images/projectimages/shopdrw3.png'
import shopdrw4 from '../Images/projectimages/shopdre9.png'
import shopdrw5 from '../Images/projectimages/shopdre8.png'





import aluminium1 from '../Images/projectimages/Aluminum Frame.png';
import aluminium2 from '../Images/projectimages/aluminium2.png';


import sculpture1 from '../Images/projectimages/butterfly.png';
import sculpture2 from '../Images/projectimages/butterfly_2.png';

import platform1 from '../Images/projectimages/Temporary Structures.png';

import tank1 from '../Images/projectimages/Tanks 01.png';
import tank2 from '../Images/projectimages/Tanks 02.png';
import tank3 from '../Images/projectimages/Under Ground Storage Tank in CA.png';
import tank4 from '../Images/projectimages/Silos.png';



import specialstru1 from '../Images/projectimages/Mobility Platforms & Ramps.png'



import foundations_one from '../Images/projectimages/Foundation 01.png';
import foundations_two from '../Images/projectimages/Foundation 02.png';
import foundations_three from '../Images/projectimages/Foundation 03.png';
import foundations_four from '../Images/projectimages/Foundation 04.png';
import foundations_five from '../Images/projectimages/palform5.png';
import foundations_6 from '../Images/projectimages/foundation6.png';
import foundations_7 from '../Images/projectimages/rccbuildingdesign.png';

import platform2 from '../Images/projectimages/platform3.png';
import platform12 from '../Images/projectimages/platform12.png';
import platform13 from '../Images/projectimages/platformcolor12.png';



import customrenov1 from '../Images/projectimages/Strengthening of Existing Structure 01.png'
import customrenov2 from '../Images/projectimages/Strengthening of Existing Structure 02.png'
import customrenov3 from '../Images/projectimages/Evaluation of Existing Structures for new additions 01.png'
import customrenov4 from '../Images/projectimages/Evaluation of Existing Structures for new additions 02.png'


import pemb1 from '../Images/projectimages/Metal Buildings 01.png'
import pemb2 from '../Images/projectimages/Metal Buildings 02.png'
import pemb3 from '../Images/projectimages/PEB Buildings.png'

import retainingwall1 from '../Images/projectimages/Segmental Retaining walls.png'
import retainingwall2 from '../Images/projectimages/retaliningwall2.png'
import retainingwall3 from '../Images/projectimages/retaining7.png'



import playground1 from '../Images/projectimages/playground1.png'
import playground2 from '../Images/projectimages/playground2.png'
import playground3 from '../Images/projectimages/playground3.png'
import playground4 from '../Images/projectimages/playground4.png'
import playground5 from '../Images/projectimages/playground5.png'
import playground6 from '../Images/projectimages/playground6.png'
import playground7 from '../Images/projectimages/playground7.png'
import playground8 from '../Images/projectimages/playground8.png'

import precast1 from '../Images/projectimages/prescast1.png'
import precast2 from '../Images/projectimages/precast2.png'
import precast3 from '../Images/projectimages/precastimg3.png'
import precast4 from '../Images/projectimages/precast7.png'
import precast5 from '../Images/projectimages/precast8.png'
import precast6 from '../Images/projectimages/precast9.png'


import warehouse_one from '../Images/projectimages/Warehouse-steel structure.png';
import warehouse_2 from '../Images/projectimages/pemb2.png';

import warehouse_two from '../Images/projectimages/WareHouse Buildings.png';
import warehouse_three from '../Images/projectimages/WareHouse Buildings 02.png';
import warehouse_4 from '../Images/projectimages/ware4.png';


import machine_house from '../Images/projectimages/machine house.png';
import machine_house1 from '../Images/projectimages/machinehouse2.png';
import machine_house2 from '../Images/projectimages/machinehouse3.png';


import glass_structure_one from '../Images/projectimages/Glass House-1.png';
import glass_structure_two from '../Images/projectimages/Glass Arch 00.png';
import glass_structure_three from '../Images/projectimages/Glass Connections 02.png';
import glass_structure_four from '../Images/projectimages/Glass Connections 01.png';
import glass_structure_five from '../Images/projectimages/Glass House Design.png';
import glass_structure_six from '../Images/projectimages/Glass Cabinets with Steel Framing for World Class Museum 02.png';
import glass_structure_seven from '../Images/projectimages/Glass Cabinets with Steel Framing for World Class Museum 01.png';
import glass_structure_8 from '../Images/projectimages/Cabinet Design and anchorage.png';
import glass_structure_9 from '../Images/projectimages/ELectric Panel Cabinet and anchor Design.png';

import industrialequ1 from '../Images/projectimages/Industrial Equipment Platform, foundation and anchor design 01.png';
import industrialequ2 from '../Images/projectimages/Industrial Equipment Platform, foundation and anchor design 02.png';
import industrialequ3 from '../Images/projectimages/Industrial Equipment support framing, foundation and anchor design 00.png';
import industrialequ4 from '../Images/projectimages/Heavy Duty Pipe Supports 01.png';
import industrialequ5 from '../Images/projectimages/Heavy Duty Pipe Supports 02.png';
import industrialequ6 from '../Images/projectimages/Heavy Duty Pipe Supports 03.png';

import poolhouse1 from '../Images/projectimages/Pool House with Retractable canopy in NY.png';
import poolhouse2 from '../Images/projectimages/Pool House with Retractable canopy in NY 02.png';

import domehouse1 from '../Images/projectimages/concrete dome house-1.png'
import domehouse2 from '../Images/projectimages/concrete dome house-2.png'
import domehouse3 from '../Images/projectimages/Dome house..png'

import unistrut1 from '../Images/projectimages/unistrut1.png';
import unistrut2 from '../Images/projectimages/unistrut2.png';

import hrs1 from '../Images/projectimages/hrs5.png';
import hrs2 from '../Images/projectimages/hrs6.png';
import hrs3 from '../Images/projectimages/hrs7.png';
import hrs9 from '../Images/projectimages/hrs9.png';
import hrs15 from '../Images/projectimages/hrs15.png';




import cablebracing1 from '../Images/projectimages/cablebracing1.png';
import cablebracing2 from '../Images/projectimages/cablebracing2.png';

import canopy1 from '../Images/projectimages/canopy1.png';
import canopy2 from '../Images/projectimages/canopy2.png';
import canopy3 from '../Images/projectimages/canopy3.png';
import canopy4 from '../Images/projectimages/canopy4.png';
import canopy5 from '../Images/projectimages/canopy5.png';
import canopy6 from '../Images/projectimages/canopy6.png';



import tower1 from '../Images/projectimages/tower structure.png';
import tower2 from '../Images/projectimages/tower1.png';

import letterdesign2 from '../Images/projectimages/letterdesign1.png';

import laddar from '../Images/projectimages/laddar1.png';

import trussdesign1 from '../Images/projectimages/trussdesign1.png';
import trussdesign2 from '../Images/projectimages/trussdesign2.png';
import trussdesign3 from '../Images/projectimages/truss3.png';



import rackdesign1 from '../Images/projectimages/rack1.png';
import rackdesign2 from '../Images/projectimages/rack2.png';







const ProjectDetails = () => {
    const location = useLocation();
    const project = location.state?.project;

    const navigate = useNavigate();

    const selectedProject = project;



    const projectImagesMap = {
        'tanks': [
            // {
            //     img: tank1,
            //     desc: "Storage Tank",
            // },
            // {
            //     img: tank2,
            //     desc: "Tanks for Industrial use",
            // },
            {
                img: tank3,
                desc: "Tanks for Industrial use",
            },
            {
                img: tank4,
                desc: "Steel Silos",
            },
        ],
        'shop drawings': [


            {
                img: shopdrw1,
                desc: "Shop Drawings for Reinforced Concrete (Cast-in-Place) Structures",
            },
            {
                img: shopdrw2,
                desc: "Shop Drawings for Steel Structures",
            },
            {
                img: shopdrw3,
                desc: "",
            },
            {
                img: shopdrw4,
                desc: "Shop Drawings for Pre-cast Panels",
            },
            {
                img: shopdrw5,
                desc: "Shop Drawings for Pre-cast Panels",
            },

        ],
        'rcc': [
            {
                img: foundations_one,
                desc: "",
            },
            {
                img: foundations_two,
                desc: "Casting of Slab on Grade with Piles",
            },
            {
                img: foundations_three,
                desc: "",
            },
            {
                img: foundations_four,
                desc: "",
            },
            {
                img: foundations_6,
                desc: "FEM Model of Slab on Grade with Piles",
            },
            {
                img: foundations_7,
                desc: "RCC Building Design ",
            },
        ],
        'hot rolled steel': [

            {
                img: hrs1,
                desc: "",
            },
            {
                img: hrs2,
                desc: "",
            },
            {
                img: hrs3,
                desc: "",
            },
            {
                img: hrs9,
                desc: "",
            },
            {
                img: hrs15,
                desc: "",
            },
        ],
        'cold-formed steel': [
            {
                img: CFS1,
                desc: "Multi Story Structures",
            },
            {
                img: CFS2,
                desc: "Single Family Residence",
            },
            {
                img: CFS3,
                desc: "Modular & Container Homes",
            },
        ],
        'aluminium': [
            {
                img: aluminium1,
                desc: "An aluminum Platform to support an aeroplane tail for maintenance.",
            },
            {
                img: aluminium2,
                desc: "An aluminum Platform to support an aeroplane tail for maintenance.",
            },
        ],
        'precast': [
            {
                img: precast1,
                desc: "Steel framing and Truss Joist & Girder Design",
            },
            {
                img: precast2,
                desc: "PRECAST TILT-UP WALL PANELS",
            },
            {
                img: precast3,
                desc: "Tilt-up & Sandwich Panel Design",
            },
            {
                img: precast4,
                desc: "",
            },
            {
                img: precast5,
                desc: "",
            },
            {
                img: precast6,
                desc: "",
            },
        ],
        'lumber structure': [
            {
                line: lumber_structure_line_one,
                color: lumber_structure_color_one,
                desc: 'Residence in Hawaii',
            },
            {
                img: lumber1,
                desc: "Residence in PA",
            },
            {
                img: lumber2,
                desc: "Residence in PA",
            },
            {
                img: lumber3,
                desc: "Residence in PA",
            },
            {
                img: lumber4,
                desc: "Wooden Cabinet Buildings",
            },
            {
                img: lumber5,
                desc: "Residence in AZ",
            },
        ],
        'machine house': [
            {
                img: machine_house2,
                desc: '',
            },
            {
                img: machine_house,
                desc: 'Exterior Framing and Shell of a Stand Alone Machine House with house refrigeration equipment',
            },
            {
                img: machine_house1,
                desc: '',
            },
        ],
        'custom renovation': [
            {
                img: customrenov1,
                desc: 'Strengthening of Existing Structure',
            },
            {
                img: customrenov2,
                desc: 'Strengthening of Existing Structure',
            },
            {
                img: customrenov3,
                desc: 'Strengthening for new additional loading ',
            },
            {
                img: customrenov4,
                desc: 'Strengthening for new additional loading ',
            },
        ],
        'log-house': [
            // {
            //     img: loghouse1,
            //     desc: "add dsce here about that img",
            // },
            {
                img: loghouse2,
                desc: "",
            },
            {
                img: loghouse3,
                desc: "Architectural View of Log House ",
            },
            {
                img: loghouse4,
                desc: "",
            },
        ],
        'warehouse design': [

            {
                img: warehouse_two,
                desc: "3D View of Warehouse",
            },
            {
                img: warehouse_three,
                desc: "3D View of Warehouse",
            },
            {
                img: warehouse_4,
                desc: "",
            },
        ],
        'clean room': [
            {
                img: cleanroom1,
                desc: "",
            },
            {
                img: cleanroom2,
                desc: "",
            },
        ],
        'sculpture': [
            {
                img: sculpture1,
                desc: "Butterfly Steel  Sculpture Design ",
            },
            {
                img: sculpture2,
                desc: "Butterfly Steel  Sculpture Design ",
            },
            {
                line: animalseclineone,
                color: animalseccolorone,
                desc: 'Horse Steel  Sculpture Design',
            },
        ],
        'playground equipment': [
            {
                img: playground1,
                desc: "",
            },
            {
                img: playground2,
                desc: "",
            }, {
                img: playground3,
                desc: "",
            }, {
                img: playground4,
                desc: "",
            },
            {
                img: playground5,
                desc: "",
            },
            {
                img: playground6,
                desc: "",
            },
            {
                img: playground7,
                desc: "",
            },
            {
                img: playground8,
                desc: "",
            },
        ],

        'platform': [

            // {
            //     img: foundations_five,
            //     desc: "add dsce here about that img",
            // },
            {
                line: platform12,
                color: platform13,
                desc: '',
            },
            {
                img: platform2,
                desc: "Steel Platform",
            },
            {
                img: platform1,
                desc: "Wooden Platform",
            },
        ],
        'solar panel': [
            {
                img: Solar_Panel_one,
                desc: "",
            },
            {
                img: Solar_Panel_two,
                desc: "",
            },
            {
                img: Solar_Panel_three,
                desc: "",
            },
        ],
        'kit homes': [
            {
                img: pemb1,
                desc: "Home with Double Porch",
            },
            {
                img: pemb2,
                desc: "Home with Single Porch",
            },

        ],
        'pemb': [
            {
                img: warehouse_one,
                desc: "Warehouse-steel structure",
            },
            {
                img: warehouse_2,
                desc: "VALOR STEEL BUILDINGS",
            },
            {
                img: pemb3,
                desc: "PEMB Shed",
            },


        ],
        'retaining walls': [
            {
                img: retainingwall1,
                desc: "Segmental Retaining walls",
            },
            {
                img: retainingwall2,
                desc: "Segmental Retaining Wall",
            },
            {
                img: retainingwall3,
                desc: "Cantilever Rataining Wall",
            },

        ],
        // 'pool house': [
        //     {
        //         img: poolhouse1,
        //         desc: "add dsce here about that img",
        //     },
        //     {
        //         img: poolhouse2,
        //         desc: "add dsce here about that img",
        //     },

        // ],
        'sign board': [

            {
                img: Sign_Board4,
                desc: "Advertise Board in OH",
            },
            {
                img: Sign_Board5,
                desc: "Advertise Board in FL",
            },
            {
                img: Sign_Board8,
                desc: "",
            },
            {
                img: Sign_Board7,
                desc: "",
            },
            {
                img: Sign_Board6,
                desc: "",
            },

        ],
        'letter design': [
            {
                img: Sign_Board,
                desc: "",
            },
            {
                img: Sign_Board1,
                desc: "",
            },
            {
                img: letterdesign2,
                desc: "",
            },
            // {
            //     img: Sign_Board3,
            //     desc: "add dsce here about that img",
            // },
        ],
        'connection': [
            // {
            //     img: steel1,
            //     desc: "Steel Connection",
            // },
            // {
            //     img: steel2,
            //     desc: "Steel Connection",
            // },
            // {
            //     img: steel3,
            //     desc: "Steel Connection",
            // },
            {
                img: steel4,
                desc: "",
            },
            {
                img: steel5,
                desc: "",
            },
            {
                img: steel6,
                desc: "",
            },
            {
                img: steel7,
                desc: "",
            },
            // {
            //     img: steel8,
            //     desc: "",
            // },
            {
                img: steel9,
                desc: "",
            },
            {
                img: steel10,
                desc: "",
            },
        ],
        'earthbag home': [
            {
                img: Earthbag_Homes_01,
                desc: "Plain View Of Earthbag Home",
            },
            {
                img: Earthbag_Homes_02,
                desc: "Earthbag home is a sustainable, low-cost structure built with soil-filled bags that provide strength, durability, and natural thermal comfort",
            },
            {
                img: Earthbag_Homes_03,
                desc: "EARTHBAG HOMES IN MAKING",
            },
        ],
        'special structure': [
            {
                img: specialstru1,
                desc: "Wheelchair Lift Platform, rails & anchors",
            },
        ],
        'industrial equipment': [
            {
                img: industrialequ1,
                desc: "Equipment Platform, Anchors & foundation design",
            },
            {
                img: industrialequ2,
                desc: "Equipment Platform, Anchors & foundation design",
            },
            // {
            //     img: industrialequ3,
            //     desc: "",
            // },
            // {
            //     img: industrialequ4,
            //     desc: "",
            // },
            {
                img: industrialequ5,
                desc: "Heavy Equipment Special Supports for stability during transportation and storage",
            },
            {
                img: industrialequ6,
                desc: "Heavy Equipment Special Supports for stability during transportation and storage",
            },

        ],

        'glass structures': [
            {
                img: glass_structure_one,
                desc: "Glass House",
            },
            {
                img: glass_structure_five,
                desc: "Glass House",
            },
            {
                img: glass_structure_two,
                desc: "Glass Arch in Museum",
            },
            {
                img: glass_structure_three,
                desc: "Glass Connection",
            },
            {
                img: glass_structure_four,
                desc: "Glass Connection",
            },
            {
                img: glass_structure_seven,
                desc: "Glass Cabinets with Steel Framing for World Class Museum 01",
            },
            {
                img: glass_structure_six,
                desc: "Glass Cabinets with Steel Framing for World Class Museum 02",
            },

            {
                img: glass_structure_8,
                desc: "Cabinet Design and anchorage",
            },
            // {
            //     img: glass_structure_9,
            //     desc: "Cabinet Design and anchorage",
            // },
        ],
        'stairs, railing & ladder (lumber, steel, aluminium)': [
            {
                line: Stairs_line_one,
                color: Stairs_color_one,
                desc: 'Lumber Stair',
            },
            {
                img: Stairs_image_two,
                desc: '3D View Of Lumber Stair',
            },
            {
                img: Stairs_image_one,
                desc: 'Steel Stair',
            },
            {
                img: spiral_stair_one,
                desc: 'Spiral Stair',
            },
            {
                img: railing,
                desc: 'Steel Railing',
            },
            {
                img: laddar,
                desc: 'Aluminium Ladder',
            },


        ],
        'dome house': [
            {
                img: domehouse1,
                desc: "Concrete Dome House FEM MODEL",
            },
            // {
            //     img: domehouse2,
            //     desc: "Concrete Dome House",
            // },
            {
                img: domehouse3,
                desc: "Concrete Dome House",
            },
        ],
        'unistrut system': [
            {
                img: unistrut1,
                desc: "design of the Unistrut Structure for mounting the express camera and suspended LCD monitor at Twin Cities Hospital",
            },

            {
                img: unistrut2,
                desc: "design of unistrut support system to hang/lift the equipments",
            },
        ],
        'temporary cable bracing': [
            {
                img: cablebracing1,
                desc: "temporary cable bracing",
            },

            {
                img: cablebracing2,
                desc: "temporary cable bracing",
            },
        ],
        'canopy design': [
            {
                line: canopy1,
                color: canopy2,
                desc: '',
            },
            {
                line: canopy3,
                color: canopy4,
                desc: '',
            },
            {
                line: canopy5,
                color: canopy6,
                desc: '',
            },
        ],
        'tower structures': [
            {
                line: tower1,
                color: tower2,
                desc: '',
            },

        ],
        'truss design': [


            {
                img: trussdesign1,
                desc: "Lumber Truss",
            },
            {
                img: trussdesign3,
                desc: "Hot Rolled Truss",
            },
            {
                img: trussdesign2,
                desc: "CFS Truss",
            },

        ],
        'rack design': [
            {
                line: rackdesign1,
                color: rackdesign2,
                desc: '',
            },

        ],
    };



    const selectedImages = projectImagesMap[selectedProject.title?.toLowerCase()] || [];
    // const selectedImages = projectImagesMap[selectedProject.title] || [];


    return (
        <div style={styles.container}>
            <button style={styles.button} onClick={() => navigate(-1)}>← Back</button>

            <h2 style={styles.heading}>{selectedProject.title}</h2>
            <p style={styles.description}>{selectedProject.description}</p>

            {/* <div style={styles.imageGrid}>
                {selectedImages.map((item, index) => (
                    <div key={index} style={styles.imageCard}>
                        <img src={item.img} alt={`Project ${index}`} style={styles.image} />
                        <p style={styles.caption}>{item.desc}</p>
                    </div>
                ))}
            </div> */}

            <div style={styles.imageGrid}>
                {selectedImages.map((item, index) => (
                    <div key={index} style={styles.imageCard}>
                        {item.line && item.color ? (


                            <BeforeAfterSlider
                                lineImg={item.line}
                                colorImg={item.color}
                                desc={item.desc}
                            />

                        ) : (
                            <>
                                <img src={item.img} alt={`Project ${index}`} style={styles.image} />
                                <p style={styles.caption}>{item.desc}</p>
                            </>
                        )}
                    </div>
                ))}
            </div>


        </div>
    );
};

const styles = {
    container: {
        padding: '4% 5%',
        // background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
        backgroundColor: '#ffffff',
        // backgroundImage: AppConstant.backgroundtextilerdesign,
        minHeight: '100vh',
        color: 'white', 

    },
    heading: {
        fontSize: '2.5rem',
        fontWeight: 800,
        marginBottom: '10px',
        textAlign: 'center',
        color: '#f37021',
    },
    description: {
        fontSize: '1rem',
        textAlign: 'center',
        marginBottom: '40px',
        fontWeight: "bold",
        fontStyle: 'italic',
        marginLeft: 'auto',
        marginRight: 'auto',
        // color: 'lightgrey',
        color: '#0A1733',
        // textTransform: "capitalize",

        // textDecoration: "underline 2px rgb(255, 101, 0)",

        textUnderlineOffset: "10px",
        letterSpacing: "2px",
    },
    // imageGrid: {
    //     display: 'grid',
    //     gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    //     gap: '20px',
    // },


    imageGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)', // exactly 3 per row
        gap: '20px',
    },

    image: {
        width: '100%',
        height: '500px',        // allow image to keep natural height
        maxHeight: '600px',    // optional cap
        objectFit: 'contain',
        borderRadius: '12px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
        display: 'block',
        backgroundColor: 'white'

    },

    // imageGrid: {
    //     display: "grid",
    //     gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    //     gap: "20px",
    // },
    // image: {
    //     width: "100%",
    //     height: "250px",       // ✅ fixed height for all
    //     objectFit: "contain",    // ✅ fills box, crops overflow to keep uniform look
    //     borderRadius: "12px",
    //     boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
    //     display: "block",
    //     backgroundColor: "white"
    // },



    imageCard: {
        textAlign: 'center',
        color: 'lightgrey',
        objectFit: 'contain',
        width: '100%',
        height: '100%',
        // backgroundColor:'red'
    },

    caption: {
        marginTop: '10px',
        fontSize: '1rem',
        fontStyle: 'italic',
        // color: 'grey'
        color: '#F37021',
        fontWeight: "bold",
        textTransform: "capitalize",
    },
    button: {
        marginTop: '2rem',
        padding: '0.7rem 1.5rem',
        backgroundColor: '#F37021',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
    },

};

export default ProjectDetails;
